import { produce } from "immer";
export function dialog_openNewAutomaton(state) {
    return produce(state, draft => {
        draft.dialogState.newProject.isOpen = true;
    });
}
export function dialog_closeNewAutomaton(state) {
    return produce(state, draft => {
        draft.dialogState.newProject.isOpen = false;
    });
}
